import {
	GETMERCHANTWIRELIST_SUCCESS,
	GETMERCHANTWIRELIST_FAILED,
	RESET_GETMERCHANTWIRELIST,
	LOADING_GETMERCHANTWIRELIST,
	NETWORK_ERROR_GETMERCHANTWIRELIST
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetMerchantWireList = () => {
	return { type: RESET_GETMERCHANTWIRELIST };
};

const getMerchantWireList = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_GETMERCHANTWIRELIST });
	await partnerServices
		.post("getMerchantWireReportList", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(getMerchantWireListsuccess(res.data));
					break;
				default:
					dispatch(getMerchantWireListFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_GETMERCHANTWIRELIST,
				payload: err
			});
		});
};
function getMerchantWireListsuccess(data) {
	return {
		type: GETMERCHANTWIRELIST_SUCCESS,
		payload: data
	};
}
function getMerchantWireListFailed(data) {
	return {
		type: GETMERCHANTWIRELIST_FAILED,
		payload: data
	};
}

export { resetGetMerchantWireList, getMerchantWireList };
